<template>
  <div class="maintenanceRecord-container">
    <div class="search-layout">
      <el-form :model="queryInfo" size="medium" :label-width="formLabelWidth('md')" :inline="true">
        <!-- <el-form-item :label="$t('manage.name86')" prop="tenantId" >
          <el-select v-model="queryInfo.tenantId" :placeholder="$t('public.name1')" style="width:100%" clearable>
    <el-option
      v-for="item in tenantOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
        </el-form-item> -->
        <el-form-item :label="$t('bike.name490')" prop="searchTime">
          <el-date-picker
            style="width:400px"
            v-model="queryInfo.searchTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :range-separator="$t('public.name9')"
            :start-placeholder="$t('public.name10')"
            :end-placeholder="$t('public.name11')"
          >
          </el-date-picker>
        </el-form-item>
          <el-form-item :label="$t('bike.name467')" prop="maintainType">
            <el-select v-model="queryInfo.maintainType" :placeholder="$t('public.name1')" style="width:100%" clearable>
    <el-option
      v-for="item in maintainTypeOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
          </el-form-item>
        <el-form-item>
          <div class="bt-layout">
        <el-button type="primary" size="medium" @click="getDataList">{{ $t('public.name3') }}</el-button>
        <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
      </div>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-button type="primary" size="medium" @click="exportExcel" :loading="loading">{{ $t('manage.name60') }}</el-button>
    </div>
    <el-table :data="tableList" :span-method="objectSpanMethod" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <!-- <el-table-column label="商户名称" prop="tenantName" sortable></el-table-column> -->
      <el-table-column :label="$t('bike.name450')" prop="id" sortable min-width="100"> </el-table-column>
      <el-table-column :label="$t('bike.name451')" prop="userName" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name452')" prop="storeAddress" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name453')" prop="createTime" sortable>
        <template slot-scope="scope">
          {{ scope.row.createTime | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name278')" prop="ebikeCode" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name41')" prop="ebikeId" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name454')" prop="maintainTypeName" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name455')" prop="oldPartCode" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name456')" prop="newPartCode" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name457')" prop="filePathList" sortable>
        <template slot-scope="scope" v-if="scope.row.filePathList.length > 0">
          <el-image style="width: 50px; height: 50px" :src="scope.row.filePathList[0]" :preview-src-list="scope.row.filePathList"></el-image>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { tenantList } from '@/api/manage.js'
import { queryMaintainRecordPage, exportEbikeMaintainRecord, queryEbikeMaintainTypeList } from '@/api/operate.js'
import { downloadExcel } from '@/utils/utils'
import { getStoredLocale } from '@/config/flavor'
export default {
  computed: {
    ...mapGetters(['userinfo'])
  },
  data() {
    return {
      tenantOptions: [],
      queryInfo: {
        pageSize: 10,
        pageNumber: 1,
        tenantId: '',
        maintainType: '',
        permTenantList: [],
        startTime: '',
        endTime: '',
        searchTime: []
      },
      tableLoading: false,
      loading: false,
      total: 0,
      tableList: [],
      spanArr: [],
      pos: 0,
      maintainTypeOptions: []
    }
  },
  components: {},
  created() {
    // console.log('userinfo===', this.userinfo)
  },
  mounted() {
    this.loadOptions()
    this.getQueryEbikeMaintainTypeList()
    this.queryList()
  },
  methods: {
    getQueryEbikeMaintainTypeList() {
      const lang = getStoredLocale()
      queryEbikeMaintainTypeList({ lang: lang }).then(res => {
        if (res.data) {
          this.maintainTypeOptions = res.data.map(item => ({
            value: item.maintainType,
            label: item.maintainTypeName
          }))
        } else {
          this.maintainTypeOptions = []
        }
      }).catch(() => {})
    },
    loadOptions() {
      const data = { page: 1, limit: 500, tenantType: 2 }
      tenantList(data).then(res => {
        if (res.data.list) {
          this.tenantOptions = res.data.list.map(item => ({
            value: item.tenantId,
            label: item.tenantName
          }))
        } else {
          this.tenantOptions = []
        }
      }).catch(() => {})
    },
    getDataList() {
      this.queryInfo.pageNumber = 1
      this.queryInfo.pageSize = 10
      this.queryInfo.permTenantList = []
      if (this.queryInfo.tenantId) {
        this.queryInfo.permTenantList.push(this.queryInfo.tenantId)
      }
      this.queryList()
    },
    queryList() {
      this.tableLoading = true
      this.queryInfo.permTenantList = []
      if (this.queryInfo.tenantId) {
        this.queryInfo.permTenantList.push(this.queryInfo.tenantId)
      }
      if (this.queryInfo.searchTime) {
        const { startTime, endTime } = this.$tz.rangeToAccountQuery(this.queryInfo.searchTime)
        this.queryInfo.startTime = startTime
        this.queryInfo.endTime = endTime
      } else {
        this.queryInfo.startTime = ''
        this.queryInfo.endTime = ''
      }
      queryMaintainRecordPage(this.queryInfo).then(res => {
        if (res.code === 200) {
          this.tableList = res.data.page.records
          this.total = res.data.page.total
          this.spanArr = []
          this.pos = 0
          this.getSpanArr(this.tableList)
        } else {
          this.tableList = []
          this.total = 0
          this.spanArr = []
        }
        this.tableLoading = false
      }).catch(() => {
        this.tableLoading = false
      })
    },
    getSpanArr(data) {
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1)
          this.pos = 0
        } else {
          // 判断当前元素与上一个元素是否相同
          if (
            data[i].id === data[i - 1].id &&
            data[i].tenantName === data[i - 1].tenantName &&
            data[i].userName === data[i - 1].userName &&
            data[i].createTime === data[i - 1].createTime &&
            data[i].ebikeCode === data[i - 1].ebikeCode &&
            data[i].ebikeId === data[i - 1].ebikeId &&
            data[i].storeAddress === data[i - 1].storeAddress
          ) {
            this.spanArr[this.pos] += 1
            this.spanArr.push(0)
          } else {
            this.spanArr.push(1)
            this.pos = i
          }
        }
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 4 || columnIndex === 5 || columnIndex === 9) {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          // [0,0] 表示这一行不显示， [2,1]表示行的合并数
          rowspan: _row,
          colspan: _col
        }
      }
    },
    resetQuery() {
      this.queryInfo = {
        pageSize: 10,
        pageNumber: 1,
        tenantId: '',
        maintainType: '',
        permTenantList: [],
        startTime: '',
        endTime: '',
        searchTime: []
      }
      this.queryList()
    },
    exportExcel() {
      this.loading = true
      exportEbikeMaintainRecord(this.queryInfo)
        .then((res) => {
          this.loading = false
          downloadExcel(res, this.$t('tabmenu.name68'))
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.queryList()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.pageNumber = newPage
      this.queryList()
    }
  }
}
</script>
<style lang="scss" scoped>
.maintenanceRecord-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  .search-layout {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .bt-layout {
    display: flex;
    flex-direction: row;
    height: 36px;
  }
  .margin10 {
    padding-left: 10px;
  }
  .file-list{
    width: 70%;
    display: flex;
    justify-content: space-between;
    margin-top: -25px;

    .el-icon-close{
      font-size: 18px;
    }
  }
}
</style>
